import { render, staticRenderFns } from "./SetupButton.vue?vue&type=template&id=8cbf0b42&scoped=true"
import script from "./SetupButton.vue?vue&type=script&lang=js"
export * from "./SetupButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbf0b42",
  null
  
)

export default component.exports